module.exports = __webpack_public_path__ + "static/media/DSCF6380_segundaaparicion_319.69411867.jpg";